<template>
    <div class="g__c g__c--12" v-if="loading">
        <div class="officer-lookup-loader" aria-label="Loading" tabindex="0">
            <div class="officer-lookup-loader__wrapper">
                <span></span>
            </div>
        </div>
    </div>
  </template>
  
<script>
export default {
  props: {
    loading: Boolean
  }
};
</script>